export default {
    reboot_device_title: "Reiniciar el Dispositivo",
    reboot_device_reboot_command_has_been_sent: "Se ha enviado la orden de reinicio",
    reboot_device_error_sending_the_command: "Error al enviar el comando",
    reboot_device_sending_command_not_accepted: "El comando no se envio al dispositivo, por favor revisar el status del dispositivo",
    reboot_device_label: "¿Quieres reiniciar el dispositivo?",
    reboot_device_reboot: "Reiniciar",
    reboot_device_message_success: "Se ha recibido la solicitud para reiniciar los dispositivos. Haga clic aquí para ver el estado del cambio.",
    reboot_device_bulk_reboot: "Reinicio masivo",
}